"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var env_exports = {};
__export(env_exports, {
  IS_LOCAL: () => IS_LOCAL,
  PLATFORM_UI_STRINGS_CDN_SUBPATH: () => PLATFORM_UI_STRINGS_CDN_SUBPATH,
  PLATFORM_UI_STRINGS_CDN_URL: () => PLATFORM_UI_STRINGS_CDN_URL,
  PLATFORM_UI_STRINGS_CDN_VERSION: () => PLATFORM_UI_STRINGS_CDN_VERSION
});
module.exports = __toCommonJS(env_exports);
var PLATFORM_UI_STRINGS_CDN_URL = {
  "digital.dev.greatminds.dev": "https://ui-strings-dev.greatminds.dev",
  "digital.stage.greatminds.dev": "https://ui-strings-stage.greatminds.dev",
  "digital.uat.greatminds.dev": "https://ui-strings-uat.greatminds.dev",
  "digital.greatminds.org": "https://ui-strings.greatminds.org",
  "dev.greatminds.dev": "https://ui-strings-dev.greatminds.dev",
  "stage.greatminds.dev": "https://ui-strings-stage.greatminds.dev",
  "test.greatminds.dev": "https://ui-strings-uat.greatminds.dev",
  "dev2.greatminds.dev": "https://ui-strings-dev.greatminds.dev",
  "stage2.greatminds.dev": "https://ui-strings-stage.greatminds.dev",
  "test2.greatminds.dev": "https://ui-strings-uat.greatminds.dev",
  "digital2.greatminds.org": "https://ui-strings.greatminds.org",
  "dp-development-docs.k8s.dev.greatminds.dev": "https://ui-strings-dev.greatminds.dev",
  localhost: "https://ui-strings-dev.greatminds.dev"
};
var PLATFORM_UI_STRINGS_CDN_SUBPATH = "packages";
var PLATFORM_UI_STRINGS_CDN_VERSION = "latest";
var IS_LOCAL = typeof window !== "undefined" ? window.location.hostname === "localhost" : false;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  IS_LOCAL,
  PLATFORM_UI_STRINGS_CDN_SUBPATH,
  PLATFORM_UI_STRINGS_CDN_URL,
  PLATFORM_UI_STRINGS_CDN_VERSION
});
//# sourceMappingURL=env.js.map